import { createProxy } from './create-proxy.util';
import { EnvironmentLoader } from './environment-loader.util';
import { Environment } from './environment.interface';

export const environment: Environment = createProxy({} as Environment);
